export function testimonialCarousel() {
  var Flickity = require("flickity");
  require("flickity-fade");

  var testimonialSlider = new Flickity(".testimonial--slider", {
    cellAlign: "left",
    contain: true,
    adaptiveHeight: true,
    pageDots: false,
    fade: true,
    wrapAround: true,
  });
}
